// extracted by mini-css-extract-plugin
module.exports = {"container":"UserPhoto_container__3LH6F","photo":"UserPhoto_photo__1w9OR","rotate":"UserPhoto_rotate__2uV2V","slideIn":"UserPhoto_slideIn__TKzrt","fadeIn":"UserPhoto_fadeIn__7Aksj"};